import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { useLocation } from 'react-router'
import useSession from '../hooks/useSession'

export default function PublicRoute(props) {
    const { restricted } = props

    const location = useLocation()
    const [isLoggedIn] = useSession()

    return (
        isLoggedIn && restricted ?
            <Navigate to={location.state?.redir ?? "/"} replace /> 
                : <Outlet />
            )
}